import Vue from 'vue';
import Component from 'vue-class-component';
import SketchfabFrame from '../sketchfabFrame/SketchfabFrame.vue';
import { Prop, Inject } from 'vue-property-decorator';
import { ConfiguratorService, ConfiguratorServiceSettings, HideObjectsCommand, FilterOperators } from '../../services/sketchfab/index';
import { Store } from '@/store';
import { ServiceIdentifiers } from '@/services';
import { ComponentContainer } from '@/services/container';

import * as _ from 'lodash';

import Axios from 'axios';

import * as $ from 'jquery';

import ProductSelector from '@/components/productSelector/ProductSelector';
import { ProductDefinition, AnimationDefinition } from '@/models/configuratorx/configuratorSchema';

import Animation from '@/components/animation/Animation';
import SummaryModal from '@/components/summaryModal/summaryModal';


import Ori9 from '@/components/families/ori/Ori9';
import Ori9b from '@/components/families/ori/Ori9b';
import Ori7 from '@/components/families/ori/Ori7';
import Ori3 from '@/components/families/ori/Ori3';

import CeoDolap from '@/components/families/ceo/CeoDolap';
import CeoYuvarlakToplantiMasasi from '@/components/families/ceo/CeoYuvarlakToplantiMasasi';
import CeoEtajerliMasa from '@/components/families/ceo/CeoEtajerliMasa';
import CeoMasa from '@/components/families/ceo/CeoMasa';
import CeoOvalToplantiMasasi from '@/components/families/ceo/CeoOvalToplantiMasasi';
import CeoSehpa from '@/components/families/ceo/CeoSehpa';
import CeoToplantiMasasi from '@/components/families/ceo/CeoToplantiMasasi';
import CeoTvUnite from '@/components/families/ceo/CeoTvUnite';
import BasicEtajerliMasa from '@/components/families/basic/BasicEtajerliMasa';
import BasicKesonTasiyiciliMasa from '@/components/families/basic/BasicKesonTasiyiciliMasa';

import BasicSehpa from '@/components/families/basic/BasicSehpa';
import BasicToplantiMasa from '@/components/families/basic/BasicToplantiMasa';
import BasicWorkstationMasa from '@/components/families/basic/BasicWorkstationMasa';
import BasicYanTabanliMasa from '@/components/families/basic/BasicYanTabanliMasa';

import ApsisDolap from '@/components/families/apsis/ApsisDolap';

import ApsisToplantiMasa from '@/components/families/apsis/ApsisToplantiMasa';
import ApsisTekilMasa from '@/components/families/apsis/ApsisTekilMasa';

import ApsisEtajerliMasa from '@/components/families/apsis/ApsisEtajerliMasa';


import ApsisYanTabanliMasa from '@/components/families/apsis/ApsisYanTabanliMasa';

import ApsisWorkstationMasa from '@/components/families/apsis/ApsisWorkstationMasa';
import PideskYanTabanliMasa from '@/components/families/pidesk/PideskYanTabanliMasa';
import PideskTowerMasa from '@/components/families/pidesk/PideskTowerMasa';
import PideskToplantiMasa from '@/components/families/pidesk/PideskToplantiMasa';
import PideskSehpa from '@/components/families/pidesk/PideskSehpa';
import PideskMasa from '@/components/families/pidesk/PideskMasa';
import PideskKeson from '@/components/families/pidesk/PideskKeson';
import PideskEtajerliMasa from '@/components/families/pidesk/PideskEtajerliMasa';
import PideskDolap from '@/components/families/pidesk/PideskDolap';
import PideskDolap2 from '@/components/families/pidesk/PideskDolap2';
import Reflex9 from '@/components/families/reflex/Reflex9';
import Reflex9b from '@/components/families/reflex/Reflex9b';
import Reflex7 from '@/components/families/reflex/Reflex7';
import Reflex3 from '@/components/families/reflex/Reflex3';
import { truncate } from 'fs';
import Daphne9 from '@/components/families/daphne/Daphne9';
import Daphne9b from '@/components/families/daphne/Daphne9B';
import Daphne7 from '@/components/families/daphne/Daphne7';
import Daphne3 from '@/components/families/daphne/Daphne3';
import BasicMasa from '@/components/families/basic/BasicMasa';
import File9 from '@/components/families/file/File9';
import File9b from '@/components/families/file/File9b';
import File7 from '@/components/families/file/File7';
import File3 from '@/components/families/file/File3';
import FilePlus9 from '@/components/families/file-plus/FilePlus9';
import FilePlus9b from '@/components/families/file-plus/FilePlus9b';
import FilePlus7 from '@/components/families/file-plus/FilePlus7';
import FilePlus3 from '@/components/families/file-plus/FilePlus3';

import Satine from '@/components/families/satine/Satine';

import VirgoCaprazAyak from '@/components/families/virgo/VirgoCaprazAyak';
import VirgoBoru from '@/components/families/virgo/VirgoBoru';
import Virgo4vAyak from '@/components/families/virgo/Virgo4vAyak';


import SednaLuxe9 from '@/components/families/sednaluxe/sednaluxe9';
import SednaLuxe9B from '@/components/families/sednaluxe/sednaluxe9B';
import SednaLuxe7 from '@/components/families/sednaluxe/sednaluxe7';
import SednaLuxe3 from '@/components/families/sednaluxe/sednaluxe3';
import Habit1 from '@/components/families/habit/habit1';
import Habit2 from '@/components/families/habit/Habit2';
import Habit3 from '@/components/families/habit/Habit3';

import Volga1 from '@/components/families/volga/Volga1';
import Volga2 from '@/components/families/volga/Volga2';
import Core1 from '@/components/families/core/Core1';
import Core2 from '@/components/families/core/Core2';
import Brandon2 from '@/components/families/brandon/Brandon2';
import Brandon3 from '@/components/families/brandon/Brandon3';
import Brandon1 from '@/components/families/brandon/Brandon1';
import Balloon1 from '@/components/families/balloon/Balloon1';
import Balloon2 from '@/components/families/balloon/Balloon2';
import Balloon3 from '@/components/families/balloon/Balloon3';
import Balloon4 from '@/components/families/balloon/Balloon4';
import Parantez2liKisa from '@/components/families/parantez/Parantez2liKisa';
import Parantez2liUzun from '@/components/families/parantez/Parantez2liUzun';
import ParantezTekliKisa from '@/components/families/parantez/ParantezTekliKisa';
import ParantezTekliUzun from '@/components/families/parantez/ParantezTekliUzun';
import GordionDolap from '@/components/families/gordion/GordionDolap';
import GordionKesonTasiyiciliMasa from '@/components/families/gordion/GordionKesonTasiyiciliMasa';
import GordionMasa from '@/components/families/gordion/GordionMasa';
import GordionSehpa from '@/components/families/gordion/GordionSehpa';
import GordionToplantiMasa from '@/components/families/gordion/GordionToplantiMasa';
import Banzai2 from '@/components/families/banzai/Banzai2';
import Banzai41 from '@/components/families/banzai/Banzai41';
import Banzai42 from '@/components/families/banzai/Banzai42';
import BanzaiSoft from '@/components/families/banzai/BanzaiSoft';
import Banzai2Soft from '@/components/families/banzai/Banzai2Soft';

import M9b from '@/components/families/m4/M9b';
import M9 from '@/components/families/m4/M9';
import M3 from '@/components/families/m4/M3';
import M7 from '@/components/families/m4/M7';
import GordionEtajerliMasa from '@/components/families/gordion/GordionEtajerliMasa';
import Puf from '@/components/families/puf/Puf';
import Banko from '@/components/families/banko/Banko';
import Adapta1 from '@/components/families/adapta/Adapta1';
import Adapta2 from '@/components/families/adapta/Adapta2';
import Adapta3 from '@/components/families/adapta/Adapta3';
import BasicAhsapKapakliDolap from '@/components/families/basicdolap/BasicAhsapKapakliDolap';
import BasicYarimAhsapKapakliCamDolap from '@/components/families/basicdolap/BasicYarimAhsapKapakliCamDolap';
import BasicCamKapakliDolap from '@/components/families/basicdolap/BasicCamKapakliDolap';
import Bloom1 from '@/components/families/bloom/Bloom1';
import Bloom2 from '@/components/families/bloom/Bloom2';
import Bloom3 from '@/components/families/bloom/Bloom3';
import Cube1 from '@/components/families/cube/Cube1';
import Cube2 from '@/components/families/cube/Cube2';
import Cube3 from '@/components/families/cube/Cube3';
import Fes from '@/components/families/fes/Fes';
import Handy from '@/components/families/handy/Handy';
import Jolly1 from '@/components/families/jolly/Jolly1';
import Jolly3 from '@/components/families/jolly/Jolly3';
import PanoKanepe1 from '@/components/families/panokanepe/PanoKanepe1';
import PanoKanepe3 from '@/components/families/panokanepe/PanoKanepe3';
import PanoKanepe2 from '@/components/families/panokanepe/PanoKanepe2';
import Punto1 from '@/components/families/punto/Punto1';
import Punto2 from '@/components/families/punto/Punto2';
import Punto3 from '@/components/families/punto/Punto3';
import AeroCapraz from '@/components/families/aero/AeroCapraz';
import Aero4v from '@/components/families/aero/Aero4v';
import AeroBoru from '@/components/families/aero/AeroBoru';
import Virgo4 from '@/components/families/virgo/Virgo4';
import Aero4 from '@/components/families/aero/Aero4';
import Stark2 from '@/components/families/stark/Stark2';
import Stark3 from '@/components/families/stark/Stark3';
import StarkSehpa from '@/components/families/stark/StarkSehpa';
import Impala3 from '@/components/families/impala/Impala3';
import Impala4 from '@/components/families/impala/Impala4';
import Impala1 from '@/components/families/impala/Impala1';
import GordionTakim from '@/components/families/gordion/GordionTakim';
import Caldo1 from '@/components/families/caldo/Caldo1';
import Caldo2 from '@/components/families/caldo/Caldo2';
import Caldo3 from '@/components/families/caldo/Caldo3';
import GenesisEtajerliMasa from '@/components/families/genesis/GenesisEtajerliMasa';
import GenesisMasa from '@/components/families/genesis/GenesisMasa';
import GenesisToplantiMasa from '@/components/families/genesis/GenesisToplantiMasa';
import GenesisWorkstationMasa from '@/components/families/genesis/GenesisWorkstationMasa';
import GenesisYanTabanliMasa from '@/components/families/genesis/GenesisYanTabanliMasa';
import GenesisKesonTasiyiciliMasa from '@/components/families/genesis/GenesisKesonTasiyiciliMasa';
import OrbitKesonTasiyiciliMasa from '@/components/families/orbit/OrbitKesonTasiyiciliMasa';
import OrbitMasa from '@/components/families/orbit/OrbitMasa';
import OrbitKeson from '@/components/families/orbit/OrbitKeson';
import OrbitToplantiMasa from '@/components/families/orbit/OrbitToplantiMasa';
import OrbitDolap from '@/components/families/orbit/OrbitDolap';
import OrbitWorkstationMasa from '@/components/families/orbit/OrbitWorkstationMasa';
import BossDolap from '@/components/families/boss/BossDolap';
import BossSehpa from '@/components/families/boss/BossSehpa';
import BossEtajerliMasa from '@/components/families/boss/BossEtajerliMasa';
import BossToplantiMasa from '@/components/families/boss/BossToplantiMasa';
import SpessoDolap from '@/components/families/spesso/SpessoDolap';
import SpessoSehpa from '@/components/families/spesso/SpessoSehpa';
import SpessoEtajerliMasa from '@/components/families/spesso/SpessoEtajerliMasa';
import SpessoMasa from '@/components/families/spesso/SpessoMasa';
import CosmoKolcakli from '@/components/families/cosmo/CosmoKolcakli';
import CosmoKolcaksizVezne from '@/components/families/cosmo/CosmoKolcaksizVezne';
import CosmoKolcaksiz from '@/components/families/cosmo/CosmoKolcaksiz';
import CosmoSabit from '@/components/families/cosmo/CosmoSabit';
import PanoDik from '@/components/families/pano/PanoDik';
import PanoYuv from '@/components/families/pano/PanoYuv';
import PanoKare from '@/components/families/pano/PanoKare';
import Legend3 from '@/components/families/legend/Legend3';
import Legend7 from '@/components/families/legend/Legend7';
import Legend9 from '@/components/families/legend/Legend9';
import Worker from '@/components/families/worker/Worker';
import WorkerVeznecemberli from '@/components/families/worker/WorkerVeznecemberli';
import Idea3 from '@/components/families/idea/Idea3';
import Idea7 from '@/components/families/idea/Idea7';
import Idea9 from '@/components/families/idea/Idea9';
import ForumTekYazi from '@/components/families/forum/ForumTekYazi';
import ForumKolsuz from '@/components/families/forum/ForumKolsuz';
import ForumCiftYazi from '@/components/families/forum/ForumCiftYazi';
import ForumCiftKolcakli from '@/components/families/forum/ForumCiftKolcakli';
import JoyaYildizAyakli from '@/components/families/joya/JoyaYildizAyakli';
import JoyaSabitKolcaksiz from '@/components/families/joya/JoyaSabitKolcaksiz';
import JoyaSabitKolcakli from '@/components/families/joya/JoyaSabitKolcakli';
import T24 from '@/components/families/t24/T24';
import T24Dosemeli from '@/components/families/t24/T24Dosemeli';
import Omega3 from '@/components/families/omega/Omega3';
import Omega7 from '@/components/families/omega/Omega7';
import Omega9 from '@/components/families/omega/Omega9';
import Throne5 from '@/components/families/throne/Throne5';
import Throne7 from '@/components/families/throne/Throne7';
import Throne9 from '@/components/families/throne/Throne9';
import Power3 from '@/components/families/power/Power3';
import Power7 from '@/components/families/power/Power7';
import Power9 from '@/components/families/power/Power9';
import Mistral3 from '@/components/families/mistral/Mistral3';
import Mistral7 from '@/components/families/mistral/Mistral7';
import Mistral9 from '@/components/families/mistral/Mistral9';
import Misty3 from '@/components/families/misty/Misty3';
import Misty7 from '@/components/families/misty/Misty7';
import Misty9 from '@/components/families/misty/Misty9';
import Kuvars from '@/components/families/kuvars/Kuvars';
import Maestro from '@/components/families/maestro/Maestro';
import DesireSabit from '@/components/families/desire/DesireSabit';
import Desire4Tekerlekli from '@/components/families/desire/Desire4Tekerlekli';
import DesireYildizAyakli from '@/components/families/desire/DesireYildizAyakli';
import Dolphin9 from '@/components/families/dolphin/Dolphin9';
import Dolphin7 from '@/components/families/dolphin/Dolphin7';
import Dolphin3 from '@/components/families/dolphin/Dolphin3';
import FluentDosemeli from '@/components/families/fluent/FluentDosemeli';
import FluentArkaliksizDosemeli from '@/components/families/fluent/FluentArkaliksizDosemeli';
import FluentArkaliksiz from '@/components/families/fluent/FluentArkaliksiz';
import FluentArkalikli from '@/components/families/fluent/FluentArkalikli';
import FluentAhsap from '@/components/families/fluent/FluentAhsap';
import OrbitTakim from '@/components/families/orbit/OrbitTakim';
import GenesisTakim from '@/components/families/genesis/GenesisTakim';
import ApsisTakim from '@/components/families/apsis/ApsisTakim';
import CeoTakim from '@/components/families/ceo/CeoTakim';
import Stonebank2 from '@/components/families/stonebank/Stonebank2';
import Stonebank3 from '@/components/families/stonebank/Stonebank3';
import ChesterMakam from '@/components/families/chester/ChesterMakam';
import ChesterMisafir from '@/components/families/chester/ChesterMisafir';
import ChesterSef from '@/components/families/chester/ChesterSef';
import Mode5 from '@/components/families/rabbitwood/Mode5';
import Mode1 from '@/components/families/rabbitwood/Mode1';
import RabbitSandalyeAyak from '@/components/families/rabbit/RabbitSandalyeAyak';
import RabbitBoruAyakli from '@/components/families/rabbit/RabbitBoruAyakli';
import Shadow9 from '@/components/families/shadow/Shadow9';
import Shadow3 from '@/components/families/shadow/Shadow3';
import Dorado9 from '@/components/families/dorado/Dorado9';
import Dorado7 from '@/components/families/dorado/Dorado7';
import DutyMasa from '@/components/families/duty/DutyMasa';
import DutyEtajerliMasa from '@/components/families/duty/DutyEtajerliMasa';
import DutySehpaDikdortgen from '@/components/families/duty/DutySehpaDikdortgen';
import DutySehpaKare from '@/components/families/duty/DutySehpaKare';
import DutyToplanti from '@/components/families/duty/DutyToplanti';
import DutyToplantiKuleli from '@/components/families/duty/DutyToplantiKuleli';
import DutyWorkstation from '@/components/families/duty/DutyWorkstation';
import DutyYanTablali from '@/components/families/duty/DutyYanTablali';
import DutyYanTablaliKesonlu from '@/components/families/duty/DutyYanTablaliKesonlu';
import DeepMasa from '@/components/families/deep/DeepMasa';
import DeepEtajer from '@/components/families/deep/DeepEtajer';
import DeepDolap from '@/components/families/deep/DeepDolap';
import DeepRaf from '@/components/families/deep/DeepRaf';
import DeepSehpa from '@/components/families/deep/DeepSehpa';
import DeepKeson from '@/components/families/deep/DeepKeson';
import YukseklikAyarliMasa from '@/components/families/yam/YukseklikAyarliMasa';
import YmoodMasa from '@/components/families/ymood/YmoodMasa';
import YmoodSehpa from '@/components/families/ymood/YmoodSehpa';
import YmoodKeson from '@/components/families/ymood/YmoodKeson';
import YmoodDolap from '@/components/families/ymood/YmoodDolap';
import YmoodDolapKucuk from '@/components/families/ymood/YmoodDolapKucuk';
import PentaEtajerli from '@/components/families/penta/PentaEtajerli';
import PentaToplanti from '@/components/families/penta/PentaToplanti';
import PentaToplantiYuvarlak from '@/components/families/penta/PentaToplantiYuvarlak';
import PentaDolap from '@/components/families/penta/PentaDolap';
import PentaSehpa from '@/components/families/penta/PentaSehpa';
import MidasKesonlu from '@/components/families/midas/MidasKesonlu';
import MidasDolap from '@/components/families/midas/MidasDolap';
import MidasSehpaDikdortgen from '@/components/families/midas/MidasSehpaDikdortgen';
import MidasSehpaKare from '@/components/families/midas/MidasSehpaKare';
import MidasToplanti from '@/components/families/midas/MidasToplanti';
import MidasToplantiKuleli from '@/components/families/midas/MidasToplantiKuleli';
import NobleMasa from '@/components/families/noble/NobleMasa';
import NobleEtajer from '@/components/families/noble/NobleEtajer';
import NobleDolap from '@/components/families/noble/NobleDolap';
import NobleSehpa from '@/components/families/noble/NobleSehpa';
import SharpMasa from '@/components/families/sharp/SharpMasa';
import SharpEtajer from '@/components/families/sharp/SharpEtajer';
import SharpDolap from '@/components/families/sharp/SharpDolap';
import SharpSehpa from '@/components/families/sharp/SharpSehpa';
import SharpKeson from '@/components/families/sharp/SharpKeson';

import PufKare from '@/components/families/pufkoltuk/PufKare';
import PufElips from '@/components/families/pufkoltuk/PufElips';

import SolyTekli from '@/components/families/soly/SolyTekli';

import SolyIkili from '@/components/families/solybekleme/SolyIkili';
import SolyIkiliSehpali from '@/components/families/solybekleme/SolyIkiliSehpali';
import SolyUclu from '@/components/families/solybekleme/SolyUclu';
import SolyUcluSehpali from '@/components/families/solybekleme/SolyUcluSehpali';
import SolyDortlu from '@/components/families/solybekleme/SolyDortlu';
import SolyDortluSehpali from '@/components/families/solybekleme/SolyDortluSehpali';
import SolyBesli from '@/components/families/solybekleme/SolyBesli';

import VirgoBeklemeIkili from '@/components/families/virgobekleme/VirgoBeklemeIkili';
import VirgoBeklemeUclu from '@/components/families/virgobekleme/VirgoBeklemeUclu';

import ChesterKanepeTekli from '@/components/families/chesterkanepe/ChesterKanepeTekli';
import ChesterKanepeIkili from '@/components/families/chesterkanepe/ChesterKanepeIkili';
import ChesterKanepeUclu from '@/components/families/chesterkanepe/ChesterKanepeUclu';

import PetraKanepeTekli from '@/components/families/petrakanepe/PetraKanepeTekli';
import PetraKanepeIkili from '@/components/families/petrakanepe/PetraKanepeIkili';
import PetraKanepeUclu from '@/components/families/petrakanepe/PetraKanepeUclu';

import AralKanepeTekli from '@/components/families/aralkanepe/AralKanepeTekli';
import AralKanepeUclu from '@/components/families/aralkanepe/AralKanepeUclu';

import OregonKanepeTekli from '@/components/families/oregonkanepe/OregonKanepeTekli';
import OregonKanepeIkili from '@/components/families/oregonkanepe/OregonKanepeIkili';
import OregonKanepeUclu from '@/components/families/oregonkanepe/OregonKanepeUclu';

import SaldaKanepeTekli from '@/components/families/saldakanepe/SaldaKanepeTekli';
import SaldaKanepeUclu from '@/components/families/saldakanepe/SaldaKanepeUclu';


import { SketchfabClient } from '../../services/sketchfab/SketchfabClient';

@Component({
  components: {
    productSelector: ProductSelector,
    animation: Animation,
    Banzai2,
    Banzai41,
    Banzai42,
    BanzaiSoft,
    Banzai2Soft,
    SednaLuxe9B,
    SednaLuxe9,
    SednaLuxe7,
    SednaLuxe3,
    Ori9,
    Ori9b,
    Ori7,
    Ori3,
    CeoDolap,
    CeoEtajerliMasa,
    CeoMasa,
    CeoOvalToplantiMasasi,
    CeoSehpa,
    CeoToplantiMasasi,
    CeoTvUnite,
    CeoYuvarlakToplantiMasasi,
    BasicEtajerliMasa,
    BasicKesonTasiyiciliMasa,
    BasicMasa,
    BasicSehpa,
    BasicToplantiMasa,
    BasicWorkstationMasa,
    BasicYanTabanliMasa,
    OrbitKesonTasiyiciliMasa,
    OrbitMasa,
    OrbitKeson,
    OrbitToplantiMasa,
    OrbitWorkstationMasa,
    OrbitDolap,
    GenesisEtajerliMasa,
    GenesisKesonTasiyiciliMasa,
    GenesisMasa,
    GenesisToplantiMasa,
    GenesisWorkstationMasa,
    GenesisYanTabanliMasa,
    ApsisDolap,
    ApsisEtajerliMasa,
    BossDolap,
    BossSehpa,
    BossEtajerliMasa,
    BossToplantiMasa,
    SpessoDolap,
    SpessoSehpa,
    SpessoEtajerliMasa,
    SpessoMasa,
    ApsisTekilMasa,
    ApsisToplantiMasa,
    ApsisWorkstationMasa,
    ApsisYanTabanliMasa,
    PideskDolap,
    PideskDolap2,
    PideskEtajerliMasa,
    PideskKeson,
    PideskMasa,
    PideskSehpa,
    PideskToplantiMasa,
    PideskTowerMasa,
    PideskYanTabanliMasa,
    GordionDolap,
    GordionKesonTasiyiciliMasa,
    GordionMasa,
    GordionSehpa,
    GordionToplantiMasa,
    GordionEtajerliMasa,
    GordionTakim,
    Reflex9,
    Reflex9b,
    Reflex7,
    Reflex3,
    Daphne9,
    Daphne9b,
    Daphne7,
    Daphne3,
    File9,
    File9b,
    File7,
    File3,
    FilePlus9,
    FilePlus9b,
    FilePlus7,
    FilePlus3,
    M9b,
    M9,
    M7,
    M3,
    Satine,
    AeroCapraz,
    Aero4v,
    Aero4,
    AeroBoru,
    VirgoCaprazAyak,
    Virgo4vAyak,
    VirgoBoru,
    Virgo4,
    Habit1,
    Habit2,
    Habit3,
    Bloom1,
    Bloom2,
    Bloom3,
    Cube1,
    Cube2,
    Cube3,
    Brandon1,
    Brandon2,
    Brandon3,
    Balloon1,
    Balloon2,
    Balloon3,
    Balloon4,
    Parantez2liKisa,
    Parantez2liUzun,
    ParantezTekliKisa,
    ParantezTekliUzun,
    Stark2,
    Stark3,
    StarkSehpa,
    Volga1,
    Volga2,
    Core1,
    Core2,
    Caldo1,
    Caldo2,
    Caldo3,
    Puf,
    Banko,
    Adapta1,
    Adapta2,
    Adapta3,
    Jolly1,
    Jolly3,
    PanoKanepe1,
    PanoKanepe2,
    PanoKanepe3,
    PanoDik,
    PanoYuv,
    PanoKare,
    Punto1,
    Punto2,
    Punto3,
    Fes,
    Handy,
    Impala3,
    Impala4,
    Impala1,
    Legend3,
    Legend7,
    Legend9,
    Omega3,
    Omega7,
    Omega9,
    Throne5,
    Throne7,
    Throne9,
    Power3,
    Power7,
    Power9,
    Mistral3,
    Mistral7,
    Mistral9,
    Misty3,
    Misty7,
    Misty9,
    Dolphin3,
    Dolphin7,
    Dolphin9,
    Worker,
    WorkerVeznecemberli,
    Idea3,
    Idea7,
    Idea9,
    Kuvars,
    ForumCiftKolcakli,
    ForumCiftYazi,
    ForumKolsuz,
    ForumTekYazi,
    JoyaSabitKolcakli,
    JoyaSabitKolcaksiz,
    JoyaYildizAyakli,
    CosmoKolcakli,
    CosmoKolcaksiz,
    CosmoKolcaksizVezne,
    CosmoSabit,
    BasicCamKapakliDolap,
    BasicYarimAhsapKapakliCamDolap,
    BasicAhsapKapakliDolap,
    T24,
    T24Dosemeli,
    Maestro,
    DesireSabit,
    Desire4Tekerlekli,
    DesireYildizAyakli,
    FluentAhsap,
    FluentArkalikli,
    FluentArkaliksiz,
    FluentArkaliksizDosemeli,
    FluentDosemeli,
    OrbitTakim,
    GenesisTakim,
    ApsisTakim,
    CeoTakim,
    Stonebank2,
    Stonebank3,
    ChesterMakam,
    ChesterMisafir,
    ChesterSef,
    Mode1,
    Mode5,
    RabbitBoruAyakli,
    RabbitSandalyeAyak,
    Shadow9,
    Shadow3,
    Dorado9,
    Dorado7,
    DutyMasa,
    DutyEtajerliMasa,
    DutySehpaDikdortgen,
    DutySehpaKare,
    DutyToplanti,
    DutyToplantiKuleli,
    DutyWorkstation,
    DutyYanTablali,
    DutyYanTablaliKesonlu,
    DeepMasa,
    DeepEtajer,
    DeepDolap,
    DeepRaf,
    DeepSehpa,
    DeepKeson,
    YukseklikAyarliMasa,
    YmoodMasa,
    YmoodSehpa,
    YmoodKeson,
    YmoodDolap,
    YmoodDolapKucuk,
    PentaDolap,
    PentaEtajerli,
    PentaSehpa,
    PentaToplanti,
    PentaToplantiYuvarlak,
    MidasKesonlu,
    MidasDolap,
    MidasSehpaDikdortgen,
    MidasSehpaKare,
    MidasToplanti,
    MidasToplantiKuleli,
    NobleMasa,
    NobleEtajer,
    NobleDolap,
    NobleSehpa,
    SharpMasa,
    SharpEtajer,
    SharpDolap,
    SharpSehpa,
    SharpKeson,
    PufKare,
    PufElips,
    SolyTekli,
    SolyIkili,
    SolyIkiliSehpali,
    SolyUclu,
    SolyUcluSehpali,
    SolyDortlu,
    SolyDortluSehpali,
    SolyBesli,
    VirgoBeklemeIkili,
    VirgoBeklemeUclu,
    ChesterKanepeTekli,
    ChesterKanepeIkili,
    ChesterKanepeUclu,
    PetraKanepeTekli,
    PetraKanepeIkili,
    PetraKanepeUclu,
    AralKanepeTekli,
    AralKanepeUclu,
    OregonKanepeTekli,
    OregonKanepeIkili,
    OregonKanepeUclu,
    SaldaKanepeTekli,
    SaldaKanepeUclu,

    summaryModal: SummaryModal,
  },
})

export default class Family extends Vue
{
  private _configuratorService: ConfiguratorService = undefined;

  @Inject()
  private _container: ComponentContainer;

  @Prop()
  id: string;

  currentScreenshot: String = null;
  animations: AnimationDefinition[] = [];
  shortenUrlOfPage: string = null;

  public get seletedProduct() {
    return Store.state.product;
  }

  public get familyDesc() {
    return Store.state.family.desc;
  }

  created()
  {
    const family = Store.getFamilyById(this.id);
    if (Store.state.family !== family) {
      Store.state.family = family;
    }
    if (!Store.state.product || !family.products.includes(Store.state.product)) {
      Store.state.product = family.products[0];
      document.title = family.products[0].name;
      Store.state.selection = null;
    }

    this._configuratorService = this._container.get<ConfiguratorService>(ServiceIdentifiers.ConfiguratorService);

  }

  availableAnimationsChanged(animations) {
    this.animations = animations;

  }

  isEmpty(o) {
    for (const i in o) {
      if (o.hasOwnProperty(i)) {
        return false;
      }
    }
    return true;
  }

  public get shortUrl(): string {

    return this.shortenUrlOfPage;
  }

  public get currentHashedUrl(): string {
    const url = window.location.origin + window.location.pathname;
    const query = {
      f: Store.state.family.id,
      p: Store.state.product.id,
      s: Store.state.selection,

    };

    const hash = this.base64Encode(JSON.stringify(query.s));

    let fullUrl = `${url}/#/?f=${query.f}&p=${query.p}&s=${hash}`;
    if (url.endsWith('.html')) {
      fullUrl = `${url}#/?f=${query.f}&p=${query.p}&s=${hash}`;
    }
    if (url.endsWith('#/')) {
      fullUrl = `${url}?f=${query.f}&p=${query.p}&s=${hash}`;
    }
    if (url.endsWith('/#/')) {
      fullUrl = `${url}?f=${query.f}&p=${query.p}&s=${hash}`;
    }
    return fullUrl;

  }

  showSummary() {
    this._configuratorService.Client.getScreenShot(undefined, 640, 480).then((x) => {
      this.currentScreenshot = x;
    });

    this.shortenUrl(this.currentHashedUrl, Store.state.configuratorConfig.blLogin, Store.state.configuratorConfig.blToken);
  }

  base64Encode(val: string)
  {
    //console.log(decodeURIComponent(encodeURIComponent(val)).length);
    return btoa(decodeURIComponent(encodeURIComponent(val)));
  }

  GetCameraPosition()
  {
    this._configuratorService.Client.getCameraLookAt().then((camera) =>
    {
      window.console.log('camera.position:  ' + camera.position); // [x, y, z]
      window.console.log('camera.target:  ' + camera.target); // [x, y, z]
    });

  }

  async shortenUrl(longUrl: string, login: string, api_key: string) {

    const config = {
      params: {
        format: 'json',
        apiKey: api_key,
        login,
        longUrl,
      },

    };
    await Axios.get('https://api-ssl.bitly.com/v3/shorten?callback=?', config).then((x) => {

      this.shortenUrlOfPage = x.data.data.url;
      (<any>window).shortenUrlOfPage = this.shortenUrlOfPage;
    });


  }

  openOptionsMenu(product) {
    $('#optionTab').click();
  }

  mounted() {
 

  }
}



// WEBPACK FOOTER //
// ./src/components/family/Family.ts